import { DatabaseClient } from './client'
import { Database } from './database'

export const db = new DatabaseClient(new Database())
